// eslint-disable
// This file is generated dynamically through `node prepare-locales.js`. Please do content changes in `shopify/assets/locales/*.json`, update the filter rules in `prepare-locales.js` and run `node prepare-locales.js`.

import type { Locale } from './en'

if (!window.seebergerLocales) {
  window.seebergerLocales = {}
}

window.seebergerLocales.de = {
  general: {
    forms: {
      response: {
        error: {
          text: 'Bitte überprüfe deine Eingabe und versuche es erneut. Folgende Felder haben Fehler: ',
        },
        success: {
          text: (data: { firstname: string; subject: string }) =>
            `Vielen Dank für deine Nachricht, ${data.firstname}. Wir werden uns so schnell wie möglich bei dir bezüglich „${data.subject}“ melden.`,
        },
      },
    },
    links: {
      go_to: {
        product: (data: { productTitle: string }) =>
          `Mehr Informationen über ${data.productTitle}`,
        link: (data: { linkTitle: string }) => `Mehr über ${data.linkTitle}`,
      },
    },
  },
  accessibility: {
    close_notification: 'Benachrichtigung schließen',
  },
  products: {
    product: {
      options: {
        more_single: 'Weiterer',
        more_plural: 'Weitere',
      },
      option_name: {
        pack: 'Packung',
        pack_number: {
          '1_html': 'Einzel&shy;produkt',
          '3_html': '3 Stück',
          '6_html': '6 Stück',
          '12_html': '12 Stück',
          '24_html': '24 Stück',
          default_html: (data: { count: string }) => `${data.count} Stück`,
        },
        discount_html: (data: { percent: string }) => `Spare ${data.percent}%`,
      },
      colli_label: {
        default_html: (data: { count: string }) => `${data.count} St`,
      },
      add_to_cart: 'In den Warenkorb legen',
      add_to_cart_sm: 'In den Warenkorb',
      add_to_cart_title: (data: { productTitle: string }) =>
        `${data.productTitle} in den Warenkorb legen`,
      new: 'Neu',
      quantity: {
        input_label: (data: { product: string }) =>
          `Anzahl von ${data.product}`,
        increase: (data: { product: string }) =>
          `Erhöhe die Menge für ${data.product}`,
        decrease: (data: { product: string }) =>
          `Verringere die Menge für ${data.product}`,
      },
      price: {
        from: 'Ab',
      },
      sold_out: 'Ausverkauft',
      diet_disclaimer: 'Laut Rezeptur, Kreuzkontamination möglich.',
      sugar_disclaimer: 'Enthält von Natur aus Zucker.',
      salt_disclaimer: 'Enthält von Natur aus Salz.',
      nutrient_data: {
        title: 'Nährwertangaben',
        'title-average': 'Durchschnittliche Nährwertangaben',
        'per-unit': '100g',
        caloricvalue: 'Brennwert (in kJ/kcal)',
        fat: 'Fett',
        fat_of_which_saturates: 'davon gesättigte Fettsäuren',
        fat_of_which_mono_unsaturates: 'davon einfach ungesättigte Fettsäuren',
        carbohydrate: 'Kohlenhydrate',
        carbohydrate_of_which_sugars: 'davon Zucker',
        carbohydrate_of_which_polyols: 'davon mehrwertige Alkohole',
        carbohydrate_of_which_starch: 'davon Stärke',
        fibre: 'Ballaststoffe',
        protein: 'Eiweiß',
        salt: 'Salz',
        vitamin_e: 'Vitamin E',
        potassium: 'Kalium',
        chloride: 'Chlorid',
        calcium: 'Calcium',
        phosphorus: 'Phosphor',
        omega_3_fatty_acids: 'Omega 3 Fettsäuren',
        magnesium: 'Magnesium',
        iron: 'Eisen',
        zinc: 'Zink',
        copper: 'Kupfer',
        manganese: 'Mangan',
        fluoride: 'Fluorid',
        selenium: 'Selen',
        chromium: 'Chrom',
        molybdenum: 'Molybdän',
        iodine: 'Jod',
        fat_of_which_polyunsaturates: 'davon mehrfach ungesättigte Fettsäuren',
        vitamin_a: 'Vitamin A',
        vitamin_d: 'Vitamin D',
        vitamin_k: 'Vitamin K',
        vitamin_c: 'Vitamin C',
        thiamin: 'Thiamin',
        riboflavin: 'Riboflavin',
        niacin: 'Niacin',
        vitamin_b6: 'Vitamin B6',
        folic_acid: 'Folsäure',
        vitamin_b12: 'Vitamin B12',
        biotin: 'Biotin',
        pantothenic_acid: 'Pantothensäure',
      },
      'filter-p-m-seeberger-diet': {
        label: 'Diät',
        'gluten-free': 'glutenfrei',
        'lactose-free': 'laktosefrei',
        vegan: 'vegan',
        vegetarian: 'vegetarisch',
        'no-added-sugar': 'ohne Zuckerzusatz',
        'no-added-salt': 'ohne Salzzusatz',
      },
    },
    facets: {
      filter_by_label: (data: { filter: string }) =>
        `Nach ${data.filter} filtern`,
    },
  },
  sections: {
    cart: {
      remove_title: (data: { title: string }) => `${data.title} entfernen`,
      presents: {
        button_label: 'Geschenk auswählen',
      },
    },
    'sb-popup-variant-overlay': {
      select_option: 'Bitte wähle eine Option',
      select_option_zustand: 'Ganze Bohne oder gemahlen?',
      select_option_inhalt: 'Wie viel darf es sein?',
      select_option_packung: 'Wie viele Packungen?',
      title: '',
    },
  },
  localization: {
    international: 'International',
    country_section: 'Lieferland',
    language_section: 'Sprache',
    country_section_desc: 'Wähle das Land aus, in das wir liefern sollen.',
    language_section_desc: 'Wähle deine bevorzugte Sprache aus.',
    redirect_title: 'Weiterleitung',
    redirect_message:
      'Du wirst in Kürze zur gewählten Sprachversion %selection% weitergeleitet.',
    non_order_options: 'Auswahl ohne Bestellmöglichkeit',
  },
  'customer-favorites': {
    'add-to-favorites': 'Zu Favoriten hinzufügen',
    'remove-from-favorites': 'Von Favoriten entfernen',
  },
  subscription: {
    discount_html: (data: { value: string }) => `Spare ${data.value}`,
  },
} satisfies Locale
